<template>
    <div class="supplier-management-list">
        <ab-list-query @handleSelect="handleSelect">
            <template #right>
                <el-row :gutter="20">
                <el-col :span="4">
                    <el-input
                    placeholder="供应商编号"
                    v-model.trim="formSearch.nameOrNumber"
                    clearable
                    >
                    </el-input>
                </el-col>
                <el-col :span="4">
                    <el-input
                    placeholder="供应商名称"
                    v-model.trim="formSearch.name"
                    clearable
                    >
                    </el-input>
                </el-col>
                <el-col :span="4">
                    <ab-timeSearch
                        v-model="formSearch.timeRange"
                        class="searchBox"
                        startSrc="更新日期起"
                        endSrc="更新日期止"
                        @searchEvent="changeTimeRange"
                    ></ab-timeSearch>
                </el-col>
                <el-col :span="4" class="text-left">
                    <el-button @click="searchForm">搜索</el-button>
                    <el-button link class="btn-svg" @click="formSearch={}"
                    ><ab-svg name="qingchu"></ab-svg>清除</el-button
                    >
                </el-col>
                </el-row>
            </template>

            <template #toolbar>
                <el-button type="primary" @click="addHandlerEdit">新增</el-button>
                <el-button @click="delAddressAll" :loading="btnsLoading.delAddressAll">批量删除</el-button>
                <el-button @click="handleExport" :loading="btnsLoading.export">导出</el-button>
            </template>

            <template #table>
                <ab-table
                stripe
                showSelection
                class="materialTable"
                ref="table"
                :column-list="columns"
                showEdit
                indexWidth="50"
                widths="200"
                isFilter="operator"
                :dataListLoading="btnsLoading.isloading"
                :table-list="tableData"
                @filterColumns="filterColumns"
                :handleSelectionChange='handleSelectionChange'
                >
                    <template #operator="scope">
                        <el-button type="primary" link @click="showDetail(scope.row.id)">编辑</el-button>
                        <!-- <i class="dividingLine"></i> -->
                        <el-button link @click="delAddress(scope.row)" class="redBtn">删除</el-button>
                </template>
                </ab-table>
            </template>

            <template #page>
                <ab-page
                :pageTotal="page.total"
                :currentPage="page.currentPage"
                :pageSize="page.pageSize"
                :pageSizes="page.pageSizes"
                @searchForm="pageSearch"
                ></ab-page>
            </template>
        </ab-list-query>
    </div>
</template>

<script>
export default {
  name: 'supplier-management-list',
  data() {
    return {
        formSearch: {},
        //状态汇总
        btnsLoading:{
            export:false,
            isloading:false,
            delAddressAll:false
        },
        supplierManagementList:[],
        // 表格数据
        columns: [
            {
                labels: '供应商编号',
                props: 'number',
                widths: 100,
            },
            {
                labels: '更新时间',
                widths: 100,
                props: 'updateTime'
            },
            {
                labels: '供应商名称',
                widths: 120,
                props: 'name'
            },
            {
                labels: '地址',
                widths: 60,
                props: 'address'
            },
        ],
        tableData: [],
        page: {
            currentPage: 1,
            pageSize: 10,
            pageSizes: [10, 20, 50, 100],
            total: 0,
        },
    };
  },
  watch:{
    editFormSearch(){
        this.changeBizTypeGroup()
    }
  },
  methods: {
    filterColumns(array) {
      this.columns = array;
    },
    pageSearch(obj) {
      this.page.currentPage = obj.currentPage;
      this.page.pageSize = obj.pageSize;
      this.getListData();
    },
    handleSelect(val) {},
    //日期
    changeTimeRange (obj) {
    this.formSearch.timeRange=obj
        if (obj) {
            this.formSearch.updateTimeStart = obj[0]
            this.formSearch.updateTimeEnd = obj[1]
        } else {
            this.formSearch.updateTimeStart = ''
            this.formSearch.updateTimeEnd = ''
        }
        this.searchForm()
    },
    searchForm(){
        this.getListData()
    },
    getListData () {        
        let data = Object.assign({}, this.formSearch, { pageNum: this.page.currentPage, pageSize: this.page.pageSize })

        if (this.btnsLoading.export) {
            data.columns = this.columns.map(row => { return row.props })
            this.$post('/bas/client/basSupplier/exportByColumns', data).then(({data}) => {
                if (data.code === 'C0000') {
                    this.$message.success(data.message)
                    let eleLink = document.createElement('a')
                    eleLink.download = ''
                    eleLink.style.display = 'none'
                    // 字符内容转变成blob地址
                    eleLink.href = data.result
                    // 触发点击
                    document.body.appendChild(eleLink)
                    eleLink.click()
                    // 然后移除
                    document.body.removeChild(eleLink)
                }
            })
            .finally(() => {
                this.btnsLoading.export=false
            })
        } else {
            this.btnsLoading.isloading=true
            this.$post('/bas/client/basSupplier/list', data)
            .then(({ data }) => {
                if (data.code === 'C0000') {
                this.tableData = data.result.list
                this.page.total = data.result.total
                }
            })
            .finally(() => {
                this.btnsLoading.isloading=false
            })
        }
    },
    //新增
    addHandlerEdit(){
        this.$router.push(
            {
                path: '/supplier-management-add',
                query: { status: 'add', cache: false
            }
        })
    },
    //编辑
    showDetail (id) {
      this.$router.push({
        path: '/supplier-management-add',
        query: {
          action: 'detail',
          id: id,
          cache: false
        }
      })
    },
    //导出
    handleExport(){
        this.btnsLoading.export=true
        this.getListData()
    },
    delAddress (row) {
        this.$confirm(`确定要删除吗?删除后将无法恢复，请谨慎操作！`, '温馨提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            this.btnsLoading.table = true
            this.$get('/bas/client/basSupplier/del', { id: row.id })
            .then(({ data }) => {
                if (data.code === 'C0000') {
                this.$message({
                    type: 'success',
                    message: data.message,
                    offset: 380,
                    grouping: true,
                })
                this.getListData()
                }
            })
        })
    },
    //批量删除
    handleSelectionChange(arr){
        this.supplierManagementList=arr
    },
    delAddressAll(){
        this.$confirm(`确定删除选中行？`, '温馨提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            this.btnsLoading.table = true
            this.$post('/bas/client/basSupplier/batchDel', { ids: this.supplierManagementList.map(row => { return row.id }) }).then(({ data }) => {
                if (data.code === 'C0000') {
                this.$message.success(data.message)
                this.getListData()
                }
            })
        })
    }
  },
  created(){
    this.getListData()
  },
  activated() {
    this.getListData()
  },

};
</script>

<style lang='scss'>
    .supplier-management-list{
       .ab-list-query{
            .el-menu {
                display: none;
            }
       } 
        .redBtn {
            margin-left: 10px;
        }
    }
</style>